export default "__VITE_ASSET__wZrsW7x___"